export const environment = {
	APP_API_URL: 'https://duroplyaiassistantapi.prowessbeat.com/api',
	// APP_API_URL: 'https://marketlenscoreapi.prowessbeat.net/api',
	APP_PUBLIC_KEY:'-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5AGHJaknTtN6gA+NjGz+brIwYiLcilh/xOsYWKe0246LPXfEg0GvJwyjA0DA2kHvTCI/dD0TXTQJLdIhAHPDJRltxi4m6diTBt/uAUGPwUwWKHmYN1vX+NRME2XFR4wn1WG0LkL6VQFMQP6RWuNbckmOIIuQBkq3/5hYly8+W9P4VFMU0BULOLtc1uwMwpNarWiloEw1jkXsfhkIo2/UNb4XExmHCM67JANH8lpMPLPMwgtA2dvkDbX1gBWPBqVrWSfRR6EE9VcXQltzJyDMfTr2Ryugop546FvydrMMVU/RQplMnbQGP3Jw6KMQIFTsA2hGGgrOfC35S/rq52IqwwIDAQAB\n-----END PUBLIC KEY-----',
};

